module.exports = __webpack_public_path__ + "img/tokenBox26.7aacd3d8.png";